import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent, CardHeader,
  Chip,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  List, ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Select,
  Typography
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import CropFreeIcon from '@material-ui/icons/CropFree';
import PageviewIcon from '@material-ui/icons/Pageview';
import SendIcon from '@material-ui/icons/Send';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import QrBarkodPopup from 'src/components/BarcodePopup';
import axios from 'src/utils/axios';
import { getUser, safeParseInt } from 'src/utils/Common';
import {
  loadBaslandiJob
} from 'src/utils/storage/StartWorkOrder';


const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsComplementary: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policyComplementary: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckboxComplementary: {
    marginLeft: '-14px'
  },
  submitButtonComplementary: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  contentComplementary: {
    minHeight: 430,
  },

  submitButtonTamamlayiciSatis: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  searchInputCC: {
    flexGrow: 1
  },
  searchCC: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  searchIconCC: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

function ComplementaryProductSales({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [Satistutar, setSatisTutar] = useState(0);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [TamamlayiciUrunData, setTamamlayiciUrunData] = useState([]);
  const SessionUser = getUser();
  const [SelectedValue, setSelectedValue] = useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [SatistahsilatTipi, setSatisTahsilatTipi] = useState(0);
  const [tamamlayiciUrunFisNo, setTamamlayiciUrunFisNo] = useState(0);
  const [TokenPayPopupOpen, setTokenPayPopupOpen] = useState(false);
  const [FilterPaper, setFilterPaper] = useState('');
  const [openQrBarkod, setOpenQrBarkod] = useState(false);
  const [QrBarkod, setQrBarkod] = useState('');
  const [tutar, setTutar] = useState(0);
  const [olizIndirim, setOlizIndirim] = useState(0);
  const [TRXNumber, setTRXNumber] = useState("");


  let currSalesMaterialSum = 0;
  let SonlandirData = readonly
    ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : [])
    : loadBaslandiJob();

  // SonlandirData'nın array olduğundan ve en az 1 eleman içerdiğinden emin ol
  if (!Array.isArray(SonlandirData)) {
    SonlandirData = [];
  }

  // İlk elemanı güvenli bir şekilde al
  const jobData = SonlandirData[0] || {};

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleChangeSatisTahsilatTipi = (event) => {
    setSatisTahsilatTipi(event.target.value);
  };

  const malzemeGosterSatisFiyatComplementary = (materialCode) => {
    const dataSatisFiyatComplementary = {
      MALZEME_STOK_NO: materialCode,
    };
    const configSatisFiyatComplementary = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    let newWindow = window.open();
    if (!newWindow) {
      alert('Popup engelleyici aktif. Lütfen bu site için popup\'lara izin verin.');
      return;
    }
    axios.post('/FileImportExport/ArtemisMalzeme', dataSatisFiyatComplementary, configSatisFiyatComplementary)
      .then(response => {
        var fileURLComplementary = URL.createObjectURL(response.data);
        newWindow.location = fileURLComplementary;
        newWindow.document.title = materialCode;
      })
  }
  const handleChangeSatisTutar = (value) => {
    setSatisTutar(value);
  }


  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetArtemisSatisAksesuarFiyat').then((response) => {
        if (mounted) {
          const Deger = response.data;
          if (Deger.length === 0) {
            setTamamlayiciUrunData([]);
          } else {
            setTamamlayiciUrunData(Deger);
          }
          setLoadingControl(false);
        }
      })
    };
    fetchTodos();
    return () => {
      mounted = false;
    };

  }, []);


  SelectedValue.forEach((mrow) => {
    currSalesMaterialSum += (mrow.KDVLI_FIYAT);
  });

  const setAdetValue = (event, MalzemeStokNo) => {
    const inputValue = event.target.value;
    
    // Kullanıcı değeri sildiğinde boş string olarak bırak (yazarken silebilsin)
    if (inputValue === '' || inputValue === null) {
      const selectedChangeData = [];
      SelectedValue.forEach(function (h) {
        selectedChangeData.push({
          ACIKLAMA: h.ACIKLAMA,
          ADET: h.MALZEME_STOK_NO === MalzemeStokNo ? '' : h.ADET,
          INDIRIM_ORANI: h.INDIRIM_ORANI,
          KDVLI_FIYAT: h.MALZEME_STOK_NO === MalzemeStokNo ? 0 : h.KDVLI_FIYAT,
          MALZEME_STOK_NO: h.MALZEME_STOK_NO,
          BAZ_FIYAT: h.BAZ_FIYAT,
        })
      });
      setSelectedValue(selectedChangeData);
      return;
    }
    
    const parsedValue = parseInt(inputValue, 10);
    var SecimAdet = (!isNaN(parsedValue) && parsedValue > 0) ? parsedValue : 1;
    
    const selectedChangeData = [];
    SelectedValue.forEach(function (h) {
      const newAdet = h.MALZEME_STOK_NO === MalzemeStokNo ? SecimAdet : (parseInt(h.ADET, 10) || 1);
      selectedChangeData.push({
        ACIKLAMA: h.ACIKLAMA,
        ADET: newAdet,
        INDIRIM_ORANI: h.INDIRIM_ORANI,
        KDVLI_FIYAT: h.MALZEME_STOK_NO === MalzemeStokNo ? h.BAZ_FIYAT * SecimAdet : h.KDVLI_FIYAT,
        MALZEME_STOK_NO: h.MALZEME_STOK_NO,
        BAZ_FIYAT: h.BAZ_FIYAT,
      })
    });
    setSelectedValue(selectedChangeData);

  }


  const handleComplementaryProductSales = () => {
    var Uyari = "Tamamlayıcı Ürün Satışı yapmak istediğinizden emin misiniz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleComplementaryProductSalesYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };
  const handleComplementaryProductSalesYes = () => {
    if (SelectedValue === undefined || SelectedValue?.length === 0 || SelectedValue === '') {
      setUyariAciklama("Lütfen satış yapacagınız malzemeyi seçiniz!...");
      setUyariTip("error");
      setUyari(true);
      setLoadingControl(false);
      return;
    }

    if (!SatistahsilatTipi || SatistahsilatTipi === 0) {
      setUyariAciklama("Lütfen tahsilat tipini seçiniz!...");
      setUyariTip("error");
      setUyari(true);
      setLoadingControl(false);
      return;
    }

    setLoadingControl(true);

    const tamamlayiciMalzemeList = SelectedValue
      .filter(x => x.MALZEME_STOK_NO)
      .map(x => {
        const parsedAdet = parseInt(x.ADET, 10);
        return {
          MALZEME_STOK_NO: String(x.MALZEME_STOK_NO),
          ADET: (!isNaN(parsedAdet) && parsedAdet > 0) ? parsedAdet : 1
        };
      });


    const dataSales = [{
      FIS_NO: FisNo,
      USER_ID: SessionUser.OrganizationUserId,
      TAHSILAT_TIPI: SatistahsilatTipi,
      SATIS_TUTAR: safeParseInt(Satistutar),
      TAMAMLAYICIMALZEME: tamamlayiciMalzemeList,
    }];
    const configSales = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisComplementaryProductSales', dataSales, configSales).then((response) => {
      setLoadingControl(false);
      const res = response.data;
      if (res.ErrorCode === 0) {
        setUyariAciklama(res.ErrorDescription);
        setUyariTip("success");
        setUyari(true);
        setLoadingControl(false);
        setTamamlayiciUrunFisNo(res.ServicePaperId);
        if (SatistahsilatTipi !== 6) {
          if (olizIndirim === 1) {
            const config = {
              headers: { 'Content-Type': 'application/json' }
            };
            var data = {
              FisNo: res.ServicePaperId.toString(),
              TRXNO: TRXNumber,
              Token: QrBarkod,
              Tutar: Satistutar
            };
            axios.post('/SetOlizAlisverisBaslat', data, config).then((response) => {
              setLoadingControl(false);
              const res = response.data;
              if (parseInt(res.ErrorCode) !== 0) {
              }
            }
            )
          }
          setSatisTahsilatTipi(0);
          setSatisTutar(0);
          setSelectedValue([]);
        }
      } else {
        setUyariAciklama(res.ErrorDescription);
        setUyariTip("error");
        setUyari(true);
        setTamamlayiciUrunFisNo(res.ServicePaperId);
        setLoadingControl(false);
      }
    })
  };
  const ChangeFilter = (value) => {
    value = value.replaceAll(" ", "");
    if (value.substring(0, 1) === "0") {
      value = value.substring(1, value.length);
    }
    setFilterPaper(value);
  };

  const handleClosePayPopupOpen = () => {
    setTokenPayPopupOpen(false);
  }

  const handleTokenPayCreditSend = () => {
    setTokenPayPopupOpen(true);
  }

  const handleSmsGonderSmsAl = (event, Telefon, tip, FisNo, Musteri, TelefonOffline, MarkaKodu) => {
    var Uyari = "";
    let TutarDeger;
    if (Satistutar > 0) {
      TutarDeger = Satistutar;
    } else {
      TutarDeger = currSalesMaterialSum;
    }



    Uyari += Musteri + " ın " + Telefon + " numaralı telefonuna gönderilecek ödeme linki ile " + TutarDeger.toString() + " tl ödeme alınacaktır. Devam etmek ister misin?";
    const confirmation = window.confirm(Uyari)
    if (!confirmation) {
      return;
    }

    setLoadingControl(true);
    var Marka = "";

    if (parseInt(MarkaKodu) === 4) {
      Marka = "Beko"
    } else {
      Marka = "Arçelik"
    }
    const SessionUser = getUser();

    const data = [{
      FisNo: FisNo,
      Musteri: Musteri,
      Telefon: TelefonOffline,
      Tutar: TutarDeger,
      Marka: Marka,
      KullaniciId: SessionUser.OrganizationUserId
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetTokenPaySmsOdeme', JSON.stringify(data), config).then((response) => {
      setLoadingControl(false);
      setTokenPayPopupOpen(false);
      const res = response.data;
      if (res !== "ok") {
        setUyariTip('error');
        setUyariAciklama(res);
      } else {
        setUyariTip('success');
        setUyariAciklama("Sms Ödeme Linki Gönderildi!...");
        setSatisTahsilatTipi(0);
        setSatisTutar(0);
        setSelectedValue([]);
      }
      setUyari(true);
    })
  }

  const handleTokenPayCreditControl = () => {
    axios.get(`GetOderoPaymentControl/${tamamlayiciUrunFisNo}`)
      .then(response => {
        setUyariAciklama(response.data);
        setUyari(true);
      })
  };

  const handleQrBarkodClose = async (barkod) => {
    setOpenQrBarkod(false);
    if (barkod.length !== undefined) {
      setQrBarkod(barkod);
      handleOlizMüsteriTokenAl(barkod)
    }
  }

  const handleOlizMüsteriTokenAl = (barkod) => {
    if (!SelectedValue || SelectedValue.length === 0) {
      setUyariAciklama("Lütfen satış yapacağınız malzemeyi seçiniz!...");
      setUyariTip("error");
      setUyari(true);
      return;
    }

    if (readonly) return;

    if (barkod.length === 8) {

      const selectedChangeDataQS = SelectedValue.map(h => ({
        ADET: h.ADET,
        KDVLI_FIYAT: h.KDVLI_FIYAT.toString(),
        MALZEME_STOK_NO: h.MALZEME_STOK_NO,
      }));

      const data = {
        FIS_NO: FisNo,
        TOKENID: barkod,
        islemTip: "4",
        TAMAMLAYICIMALZEMEQS: selectedChangeDataQS,
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios.post('/GetOlizAlisverisBaslatTamamlayiciUrun', JSON.stringify(data), config)
        .then((response) => {
          const ResponseData = response.data;

          if (ResponseData.ErrorCode === "1000") {
            setUyari(true);
            setUyariTip('error');
            setUyariAciklama(ResponseData.ErrorDescription);
            return;
          }

          const XmlData = JSON.parse(ResponseData.ErrorDescription);

          const AlisverisData = XmlData.XmlString;

          if (AlisverisData?.SONUC === "0") {
            setUyari(true);
            setUyariTip('error');
            setUyariAciklama(AlisverisData?.ACIKLAMA);
            return;
          }

          if (AlisverisData?.INDIRIM.URUNINDIRIMLIST) {
            let urunIndirimList = AlisverisData.INDIRIM.URUNINDIRIMLIST.URUNINDIRIM;
            let indirim = 0;

            // Eğer URUNINDIRIM bir dizi ise, tüm indirimleri topla
            if (Array.isArray(urunIndirimList)) {
              urunIndirimList.forEach(item => {
                let indirimTutar = item.UINDTUTAR.replace(",", ".");
                indirim += parseFloat(indirimTutar);
              });
            } else {
              // Eğer tek bir indirim varsa, direkt değeri al
              let indirimTutar = urunIndirimList.UINDTUTAR.replace(",", ".");
              indirim = parseFloat(indirimTutar);
            }

            let newPrice = AlisverisData.INDIRIM.YENIAVTUTAR.replace(",", ".");

            setTRXNumber(AlisverisData.TRXNO);
            setSatisTutar(newPrice);
            setTutar(newPrice);
            setUyari(true);
            setUyariTip('success');
            setUyariAciklama(`Oliz Quick&Shine Kampanyası kapsamında ${currSalesMaterialSum.toFixed(
              2
            )}₺ işlem üzerinden ${indirim.toFixed(2)}₺ indirim uygulandı.`);
            setOlizIndirim(1);
          }
        });
    }
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={"Tamamlayıcı Ürün Satis"} />
      <Divider />
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }

      <CardContent className={classes.contentComplementary}>
        {
          LoadingControl ?
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
            : <div></div>
        }
        <Autocomplete
          multiple
          limitTags={1}
          id="checkboxes-tags-demo"
          options={TamamlayiciUrunData}
          disableCloseOnSelect
          onChange={(event, newValue) => {
            newValue.forEach(function (h) {
              SelectedValue.forEach(function (i) {
                if (i.MALZEME_STOK_NO === h.MALZEME_STOK_NO) {
                  h.ADET = i.ADET;
                  h.KDVLI_FIYAT = i.KDVLI_FIYAT
                }
              });
            });
            setSelectedValue(newValue);
          }}
          getOptionLabel={(option) => option.MALZEME_STOK_NO + "-" + option.ACIKLAMA}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={selected}
              />
              {option.MALZEME_STOK_NO}-{option.ACIKLAMA}-{option.KDVLI_FIYAT} ₺
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField {...params} variant="outlined"
              label="Tamamlayıcı Ürün" />
          )}
        />
        <br />
        <Divider />
        <br />
        <List className={classes.root}>
          {SelectedValue.map(log => (
            <div key={log.MALZEME_STOK_NO}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar onClick={() => malzemeGosterSatisFiyatComplementary(log.MALZEME_STOK_NO)}>
                  <Avatar style={{ backgroundColor: '#FF9800' }}>
                    <PageviewIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText>
                  <Grid container spacing={1}>
                    <Grid item xs={10} sm={10}>
                      {log.MALZEME_STOK_NO + "-" + log.ACIKLAMA + " "}
                      <Chip size="small" label={log.KDVLI_FIYAT.toFixed(2) + ' ₺'} color="secondary" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <TextField
                        id="standard-number"
                        label="Adet"
                        type="number"
                        size="small"
                        autocomplete="off"
                        onChange={e => setAdetValue(e, log.MALZEME_STOK_NO)}
                        value={log.ADET}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItemText>
              </ListItem>
              <Divider variant="inset" component="li" />
            </div>
          ))}
        </List>
        <br />
        <Divider />
        <br />
        <FormControl variant="outlined" className={classes.submitButtonTamamlayiciSatis}>
          <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Tahsilat Tipi"}</InputLabel>
          <Select
            fullWidth
            native
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            onChange={handleChangeSatisTahsilatTipi}
            label={"Tahsilat Tipi"}
            hidden={true}
            value={SatistahsilatTipi}
          >
            <option value={0}></option>
            <option value={1}>Nakit</option>
            <option value={2}>Kredi kartı</option>
            <option value={3}>Senet</option>
            <option value={4}>Borç</option>
            <option value={5}>Diğer</option>
            <option value={6}>Ödero</option>
          </Select>
        </FormControl>
        <br />
        <br />
        <Divider />
        <br />
        <br />
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} align="right">
            <Typography variant="h6" gutterBottom>
              Toplam : {currSalesMaterialSum.toFixed(2) + " ₺"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} align="right">
            <Typography variant="h6" gutterBottom>
              Yeni Tamamlayıcı Urun Satış Fişi : {tamamlayiciUrunFisNo || ''}
            </Typography>
          </Grid>
          <TextField
            name="Tutar"
            label={'İndirim Sonrası Toplam Tutar'}
            value={tutar || ''}
            type="number"
            // onChange={e => handleChangeTutar(e.target.value)}
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">₺</InputAdornment>
              )
            }}
            fullWidth
            variant="outlined"
            disabled={readonly}
          />
        </Grid>
        <br />
        <Divider />
        <br />
        <TextField
          name="Tutar"
          label={"Tahsil Edilen İndirimli Toplam Tutar"}
          value={Satistutar || ''}
          type="number"
          onChange={e => handleChangeSatisTutar(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                ₺
              </InputAdornment>
            ),
          }}
          fullWidth
          variant="outlined"
        />
        <br />
        <div className={classes.fieldsComplementary}>
          {tamamlayiciUrunFisNo > 0 ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleTokenPayCreditSend}
              className={classes.submitButton}
              endIcon={<CreditCardIcon />}
            >
              {'Ödero Sms Link Ödeme Al'}
            </Button>
          ) : null}
        </div>
        <div className={classes.fieldsComplementary}>
          {tamamlayiciUrunFisNo > 0 ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleTokenPayCreditControl}
              className={classes.submitButton}
              endIcon={<AccountBalanceWalletIcon />}
            >
              {'Ödero Ödeme Kontrol'}
            </Button>
          ) : null}
        </div>
        <br />
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.submitButton}
              onClick={() => setOpenQrBarkod(true)}
              //onClick={() => handleOlizMüsteriTokenAl('24VSZ59C')}
              endIcon={<CropFreeIcon />}>
              Oliz QR Kod Okut
            </Button>
          </Grid>
          {!LoadingControl && (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={(event) => handleComplementaryProductSales(event)}
                endIcon={<AddShoppingCartIcon />}>
                Satış Yap
              </Button>
            </Grid>
          )}
        </Grid>
      </CardActions>
      <QrBarkodPopup
        onClose={handleQrBarkodClose}
        open={openQrBarkod}
        ScanTime={0}
        CallScreen={0}
      />
      <Dialog
        open={TokenPayPopupOpen}
        onClose={handleClosePayPopupOpen}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Seçeceğiniz Telefon Numarasına Ödeme Linki Gönderilecektir!..."}</DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.wrapper}>
              {
                jobData?.Telefon !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, jobData?.Telefon, 1, tamamlayiciUrunFisNo, jobData?.Musteri, jobData?.TelefonOffline, jobData?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"Telefon1 : " + jobData?.Telefon}
                  </Button>
                  : <div></div>
              }
            </div>
            <div className={classes.wrapper}>
              {
                jobData?.Telefon2 !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, jobData?.Telefon2, 2, tamamlayiciUrunFisNo, jobData?.Musteri, jobData?.Telefon2Offline, jobData?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"Telefon2 : " + jobData?.Telefon2}
                  </Button>
                  : <div></div>
              }
            </div>
            <div className={classes.wrapper}>
              {
                jobData?.Telefon3 !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, jobData?.Telefon3, 3, tamamlayiciUrunFisNo, jobData?.Musteri, jobData?.Telefon3Offline, jobData?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"Telefon3 : " + jobData?.Telefon3}
                  </Button>
                  : <div></div>
              }
            </div>
            <div className={classes.wrapper}>
              {
                jobData?.ArayanTelefon !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, jobData?.ArayanTelefon, 4, tamamlayiciUrunFisNo, jobData?.Musteri, jobData?.ArayanTelefonOffline, jobData?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"ArayanTelefon : " + jobData?.ArayanTelefon}
                  </Button>
                  : <div></div>
              }
            </div>
            <div className={classes.wrapper}>
              {
                jobData?.IrtibatTelefon !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, jobData?.IrtibatTelefon, 5, tamamlayiciUrunFisNo, jobData?.Musteri, jobData?.IrtibatTelefonOffline, jobData?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"IrtibatTelefon : " + jobData?.IrtibatTelefon}
                  </Button>
                  : <div></div>
              }
            </div>
            <div className={classes.wrapper}>
              {
                SonlandirData[0]?.ALICI_GSM !== "" ?
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.submitButton}
                    onClick={(event) => handleSmsGonderSmsAl(event, SonlandirData[0]?.ALICI_GSM, 5, tamamlayiciUrunFisNo, SonlandirData[0]?.Musteri, SonlandirData[0]?.ALICI_GSM, SonlandirData[0]?.MARKA_KODU)}
                    endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                    {"IrtibatTelefon : " + SonlandirData[0]?.ALICI_GSM}
                  </Button>
                  : <div></div>
              }
            </div>
            <br />
            <br />
            <div className={classes.wrapper}>
              <Paper
                className={classes.searchCC}
                elevation={1}>
                <Input
                  className={classes.searchInputCC}
                  disableUnderline
                  value={FilterPaper}
                  onChange={e => ChangeFilter(e.target.value)}
                  placeholder="Diğer Telefon(5xxxxxxxxx)"
                />
                <SendIcon
                  onClick={(event) => handleSmsGonderSmsAl(event, FilterPaper, 5, tamamlayiciUrunFisNo, SonlandirData[0]?.Musteri, FilterPaper, SonlandirData[0]?.MARKA_KODU)}
                  className={classes.searchIconCC} />
              </Paper>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePayPopupOpen} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Card >
  );
}

ComplementaryProductSales.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(ComplementaryProductSales);
